"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pkyd_types = exports.LastPKYDScroll = void 0;
/**
 * 行情相关组件
 */
var react_1 = __importDefault(require("react"));
var swr_1 = __importDefault(require("swr"));
var pkyd_1 = require("../../../../modules/quote/pkyd");
var divscroll_1 = require("../../../divscroll");
require("./index.less");
/**
 * 最新消息滚动
 */
function LastPKYDScroll() {
    var _a = (0, swr_1.default)("/new50pkyd/", function () { return (0, pkyd_1.getNewPKYD)(); }, {
        refreshInterval: 60 * 1000,
        dedupingInterval: 59 * 1000
    }), data = _a.data, error = _a.error;
    if (data) {
        return (react_1.default.createElement("div", { className: "lastpkydscroll" },
            react_1.default.createElement(divscroll_1.DivScroll, null, data.filter(function (v) { return exports.pkyd_types[v.type] != undefined; }).map(function (v, index) {
                return react_1.default.createElement(react_1.default.Fragment, { key: index },
                    react_1.default.createElement("span", { className: "time" }, v.time),
                    react_1.default.createElement("a", { href: "//quote.eastmoney.com/changes/stocks/".concat(v.market == '0' ? 'sz' : 'sh').concat(v.code, ".html"), style: { color: v.color == '1' ? '#FF030F' : '#009A27' } },
                        v.name,
                        " ",
                        exports.pkyd_types[v.type],
                        " ",
                        v.intro));
            }))));
    }
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.LastPKYDScroll = LastPKYDScroll;
exports.pkyd_types = {
    "1": "有大买盘",
    "101": "有大卖盘",
    "2": "大笔买入",
    "102": "大笔卖出",
    "201": "封涨停板",
    "301": "封跌停板",
    "202": "打开涨停",
    "302": "打开跌停",
    "203": "高开5日线",
    "303": "低开5日线",
    "204": "60日新高",
    "304": "60日新低",
    "401": "向上缺口",
    "501": "向下缺口",
    "402": "火箭发射",
    "502": "高台跳水",
    "403": "快速反弹",
    "503": "快速下跌",
    "404": "竞价上涨",
    "504": "竞价下跌",
    "405": "60日大幅上涨",
    "505": "60日大幅下跌"
};
